export const KNOWN_PLATFORM_TITLE_LIMITS: Partial<Record<string, number>> = {};
